<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 55px;"></div>
		<designer />
		<div class="home">
			<div  @click="go('My')">我的主页</div>
			<div><</div>
			<div style="color: #E66617;">我的关注</div>
		</div>
		<div class="special-content">
			<div  v-for="(item, index) in list" :key="index">
				<div class="special-item1"  @click="goAuthor(item.follow_id)">
					<div>
						<img :src="imageUrl(item.head_pic)" alt="">
					</div>
					<div class="name">{{ item.nickname }}</div>
					<div class="more">查看更多</div>
				</div>
			</div>
		</div>
		<div class="page1">
			<el-pagination @current-change="handleCurrentChange" :page-size="size"
			:pager-count="5" layout="total, prev, pager, next ,jumper" :total="count">
			</el-pagination>
		</div>
		<info />
		<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
		<foot />
	</div>
</template>

<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import designer from "../../components/common/designer.vue";
	import { myFollowList } from "../../request/api";
	export default {
		components: {
			top,
			foot,
			designer,
			info
		},
	  data() {
	    return {
			list: "",
			count: 1,
			size: 6,
			page: 1,
	    };
	  },
	
	  created() {
		  document.title = '以图绘图印花设计网-我的关注';
		  this.getData();
	  },
	  methods: {
		  getData() {
		    myFollowList({
		      page: this.page,
		      size: this.size,
		    }).then((res) => {
		      console.log(res.data.followList);
		      this.list = res.data.followList;
		      this.count = res.data.count;
		    });
		  },
		  goAuthor(author_id) {
		    this.$router.push({
		      name: 'Author',
		      query: {
		        author_id: author_id,
		      },
		    });
		  },
		  go(url) {
		  	this.$router.push({
		  		name: url,
		   });
		  },
		  handleCurrentChange(val) {
		    this.page = val;
		    this.getData();
		  },
	  },
	};
</script>

<style lang="less" scoped>
	.page {
		background: #F6F6F6;
		.home {
			padding: 0 20px;
			display: flex;
			align-items: center;
			font-size: 13px;
			div {
				margin-right: 7px;
			}
		}
		.special-content {
			padding: 24px 10px 0px 10px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap:wrap;
			.special-item {
				margin-bottom: 10px;
				width: 174px;
				height: 185px;
				background: #ffffff;
				border-radius: 3px;
				cursor: pointer;
				
				img {
					width: 174px;
					height: 154px;
					display: block;
				}
				
				.special-text {
					background-color: #ffffff;
					font-size: 12px;
					font-weight: 400;
					color: #333333;
					text-align: center;
					line-height: 31px;
				}
			}
			.special-item1 {
				margin-bottom: 10px;
				width: 167px;
				height: 195px;
				background: #ffffff;
				border-radius: 3px;
				cursor: pointer;
				text-align: center;
				img {
					border-radius: 50%;
					width: 74px;
					height: 74px;
					margin-top: 15px;
				}
				.name {
					font-size: 12px;
					margin-top: 20px;
					color: #08243C;
				}
				.more {
					margin: 0 auto;
					width: 60px;
					border: 1px solid #D2D7DC;
					border-radius: 10px;
					padding: 5px 15px;
					font-size: 12px;
					margin-top: 30px;
					color: #E66617;
				}
			}
		}
		.page1 {
			position: relative;
			left: -15%;
			transform: scale(0.7);
		}
	}
</style>
